import { render, staticRenderFns } from "./PriceListOpened.vue?vue&type=template&id=6c9250b9&"
import script from "./PriceListOpened.vue?vue&type=script&lang=js&"
export * from "./PriceListOpened.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports